module.exports = __webpack_public_path__ + "static/media/APP_TimeMagician_152x174_5.947b5e48.png";